export default __webpack_public_path__ + "static/media/2d.4d2673a6.png";